export default __webpack_public_path__ + "static/media/oie_6121253ocOaJ2Zf.f6121bb1.png";